<script lang="ts">
	import { hatchStyle45 } from '$lib/styles/hatch';
</script>

<header
	class="h-14 bg-[#F9F9F4] border-b border-[#e5e5e5] flex items-center px-6 sticky top-0 z-50"
	style={hatchStyle45}
>
	<a href="/" class="flex items-center gap-3">
		<img src="/shared/images/logos/logo-and-name-black.svg" alt="Corral" class="h-5" />
	</a>
	<div class="w-px h-5 bg-[#d0d0d0] mx-4"></div>
	<a
		href="/learn"
		class="font-mono text-[11px] uppercase tracking-wider text-[#5c5855] hover:text-[#ee6018] transition-colors"
	>
		Learn
	</a>
	<span class="font-mono text-[11px] text-[#c0c0c0] mx-2">&gt;</span>
	<a
		href="/docs"
		class="font-mono text-[11px] uppercase tracking-wider text-[#878787] hover:text-[#ee6018] transition-colors"
	>
		Documentation
	</a>
</header>
